import { bankList } from './bankList';

export const foundBankByCode = (issuerCode: string) => {
  const bankName = bankList.find((bank) => bank.Code === issuerCode);
  return bankName ? bankName.Name : '--';
};
